import { render, staticRenderFns } from "./FormIcon.vue?vue&type=template&id=3ea6d668"
import script from "./FormIcon.vue?vue&type=script&lang=js"
export * from "./FormIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports